import { render, staticRenderFns } from "./OnboardingQuestionWelcome.vue?vue&type=template&id=908c28d4"
import script from "./OnboardingQuestionWelcome.vue?vue&type=script&lang=js"
export * from "./OnboardingQuestionWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports